import { render, staticRenderFns } from "./CommonTextBlock.vue?vue&type=template&id=0af4a5f9&scoped=true&"
import script from "./CommonTextBlock.vue?vue&type=script&lang=ts&"
export * from "./CommonTextBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CommonTextBlock.vue?vue&type=style&index=0&id=0af4a5f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4a5f9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSalesDialog: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonSalesDialog.vue').default})
